export const getTranslationsFromArray = (translations, lang, key) => {
    if(Array.isArray(translations)) {
        const foundTranslation = translations.find(translation => translation.iso.toLowerCase() === lang.toLowerCase());

        return foundTranslation ? foundTranslation[key || 'value'] : '';
    } else {
        throw Error('Translations must be array');
    }
};